<div style="margin-top: 20px; margin-left: 20px;">

	<form [formGroup]="settingsForm">

		<fieldset>
			<legend style="font-weight: bold;">Device Settings</legend>

			<div class="form-group row">
				<div class="uv-row">
					<span class="col-lg-2">Display Name Setting:</span>
					<select class="col-lg-2 form-control" style="width: auto; margin-left: 15px;" [formControl]="deviceDisplaySetting">
						<option value="0">Default</option>
						<option value="1">Host Name</option>
						<option value="2">IP Address</option>
					</select>
				</div>
			</div>
		</fieldset>

		<br />

		<fieldset>
			<legend style="font-weight: bold;">Map Label Drawing</legend>

			<div class="form-group row">
				<span class="col-lg-3" [ngClass]="{'has-error':!shortDeviceNames.valid}">
					<input type="checkbox" [formControl]="shortDeviceNames" (change)="enableDisableControls()" />
					<span class="uv-checkbox-label">Short Device Names</span>
				</span>
			</div>

			<div class="form-group row mb-3">
				<span class="col-lg-2" style="padding-left: 50px; position: relative; top: 5px;" [ngClass]="{'has-error':!deviceTrimLeft.valid}">
					<input type="checkbox" [formControl]="deviceTrimLeft" (change)="enableDisableControls()" />
					<span class="uv-checkbox-label">Trim Left</span>
				</span>
				<span class="col-lg-2" [ngClass]="{'has-error':!deviceTrimLeftChar.valid}">
					<span>Character:</span>
					<span style="display: inline-block;" class="uv-labeled-input">
						<input type="text" [formControl]="deviceTrimLeftChar" class="form-control"
							   style="width: 40px;" />
					</span>
				</span>
				<span class="col-lg-2" [ngClass]="{'has-error':!deviceTrimLeftCount.valid}">
					<span>Count:</span>
					<span style="display: inline-block;" class="uv-labeled-input">
						<input type="number" [formControl]="deviceTrimLeftCount" class="form-control"
							   style="width: 75px;" />
					</span>
				</span>
			</div>

			<div class="form-group row mb-3">
				<span class="col-lg-2" style="padding-left: 50px; position: relative; top: 5px;" [ngClass]="{'has-error':!deviceTrimRight.valid}">
					<input type="checkbox" [formControl]="deviceTrimRight" (change)="enableDisableControls()" />
					<span class="uv-checkbox-label">Trim Right</span>
				</span>
				<span class="col-lg-2" [ngClass]="{'has-error':!deviceTrimRightChar.valid}">
					<span>Character:</span>
					<span style="display: inline-block;" class="uv-labeled-input">
						<input type="text" [formControl]="deviceTrimRightChar" class="form-control"
							   style="width: 40px;" />
					</span>
				</span>
				<span class="col-lg-2" [ngClass]="{'has-error':!deviceTrimRightCount.valid}">
					<span>Count:</span>
					<span style="display: inline-block;" class="uv-labeled-input">
						<input type="number" [formControl]="deviceTrimRightCount" class="form-control"
							   style="width: 75px;" />
					</span>
				</span>
			</div>

			<div class="form-group row">
				<span class="col-lg-3" [ngClass]="{'has-error':!shortIfNames.valid}">
					<input type="checkbox" id="mapSettingsShortIfNames" [formControl]="shortIfNames" />
					<span class="uv-checkbox-label">Short Interface Names</span>
				</span>
			</div>

			<div class="form-group row">
				<span class="col-lg-3" [ngClass]="{'has-error':!showIpOnIfNames.valid}">
					<input type="checkbox" id="mapSettingsShowIpOnIfNames" [formControl]="showIpOnIfNames" />
					<span class="uv-checkbox-label">Show IP Address(es) on Interface Names</span>
				</span>
			</div>


		</fieldset>

		<br />

		<fieldset>
			<legend style="font-weight: bold;">Map Link Lines</legend>

			<div style="margin-left: 15px;">

				<div>
					<p>
						<label>Standard</label>
					</p>
					<div>
						<pen-pattern-selector [(lineColor)]="standardLineColor"
											  [(lineDashStyle)]="standardDashStyle"
											  [(lineWidth)]="standardLineWidth"
											  (lineColorChange)="onLineChange($event)"
											  (lineWidthChange)="onLineChange($event)"
											  (lineDashStyleChange)="onLineChange($event)">
						</pen-pattern-selector>
					</div>
				</div>

				<div>
					<p>
						<label>LAG</label>
					</p>
					<div>
						<pen-pattern-selector [(lineColor)]="lagLineColor"
											  [(lineDashStyle)]="lagDashStyle"
											  [(lineWidth)]="lagLineWidth"
											  (lineColorChange)="onLineChange($event)"
											  (lineWidthChange)="onLineChange($event)"
											  (lineDashStyleChange)="onLineChange($event)">
						</pen-pattern-selector>
					</div>
				</div>

				<div>
					<p>
						<label>Manual</label>
					</p>
					<div>
						<pen-pattern-selector [(lineColor)]="manualLineColor"
											  [(lineDashStyle)]="manualDashStyle"
											  [(lineWidth)]="manualLineWidth"
											  (lineColorChange)="onLineChange($event)"
											  (lineWidthChange)="onLineChange($event)"
											  (lineDashStyleChange)="onLineChange($event)">
						</pen-pattern-selector>
					</div>
				</div>

				<div>
					<p>
						<label>Association</label>
					</p>
					<div>
						<pen-pattern-selector [(lineColor)]="assocLineColor"
											  [(lineDashStyle)]="assocDashStyle"
											  [(lineWidth)]="assocLineWidth"
											  (lineColorChange)="onLineChange($event)"
											  (lineWidthChange)="onLineChange($event)"
											  (lineDashStyleChange)="onLineChange($event)">
						</pen-pattern-selector>
					</div>
				</div>

				<div>
					<p>
						<label>Multiple</label>
					</p>
					<div>
						<pen-pattern-selector [(lineColor)]="multiLineColor"
											  [(lineDashStyle)]="multiDashStyle"
											  [(lineWidth)]="multiLineWidth"
											  (lineColorChange)="onLineChange($event)"
											  (lineWidthChange)="onLineChange($event)"
											  (lineDashStyleChange)="onLineChange($event)">
						</pen-pattern-selector>
					</div>
				</div>

			</div>

		</fieldset>

	</form>

</div>
